import { getService as service } from '../../util/angular_helpers.js';
import { addPageAction, getNewRelicName } from '../../util/new_relic.js';

export function registerEventHandlers(element) {
  element.addEventListener('click', (event) => handleToggleClick(event));
}

export function handleToggleClick(event) {
  const triggerEl = event.target.closest('[data-analytics-class="font-images-toggle"]');
  if (!triggerEl) {
    return;
  }

  const images = document.querySelectorAll('af-family-card :is(af-frozen-img, img[slot$="sample"])');
  const toggles = document.querySelectorAll('[data-analytics-class="font-images-toggle"]');
  toggles.forEach(toggle => {
    if (toggle.classList != triggerEl.classList) {
      toggle.toggleAttribute('checked');
    }
  });

  const UserPrefsService = service('UserPrefsService');
  UserPrefsService.updatePrefs({ hideImages: triggerEl.checked });

  addPageAction(getNewRelicName('hide-images', event), { isChecked: triggerEl.checked });

  images.forEach(image => image.setAttribute('slot', triggerEl.checked ? 'hidden-sample' : 'sample'));
}
